module.exports = __webpack_public_path__ + "img/jrtx2.8542f303.png";